import { ConditionOnFieldEvaluator, operationBuilder } from './ConditionOnFieldEvaluator';
import { ViewResultTestData } from '../event/ViewResultTestEventHandler';

export class DoubleCheckConditionEvaluation extends ConditionOnFieldEvaluator {
  constructor() {
    super('doubleCheck');
  }

  isMatchCondition(condition: any, data: ViewResultTestData): boolean {
    if (this.canHandleCondition(condition)) {
      const conditionValue = condition[this.fieldName];
      const operationKeys = Object.keys(conditionValue);
      return operationKeys.every(
        (key) =>
          operationBuilder[key] && operationBuilder[key](data.isDoubleCheck, conditionValue[key])
      );
    }
    return false;
  }
}
